import React from "react";
import { Groups, Users } from "../../Assets/Icons";

const AnimatedButton = ({ group, user }) => {
  return (
    <>
      <div class="create">
        {group && (
          <a href="#" class="button">
            <div class="icon">
              <Groups />
            </div>
            <span>Groups</span>
          </a>
        )}
        {user && (
          <a href="#" class="button">
            <div class="icon">
              <Users />
            </div>
            <span>Users</span>
          </a>
        )}
      </div>
    </>
  );
};

export default AnimatedButton;
